<template>
    <div class="container padded-top">
        <div id="discount-logic" class="container">
            <div class="row">
                <div class="col-sm-8 with-border">

                    <h2 class="page-title uppercase large-margin">Discounts Logic</h2>

                    <div class="activities">
                        <div class="media-box d-flex ac">
                            <div>
                                <h3 class="activity-title">BUNGY</h3>
                            </div>
                            <div>
                                <div :class="'activity-box no-min-height d-flex align-items-center'">
                                    <select class="select" id="dl-bj" v-select2 v-model="discountLogicSettings.bj">
                                        <option v-for="index in 15" :key="index" :value="index" :selected="discountLogicSettings.bj == index">{{ index }}</option>
                                    </select>
                                    <label>activities to get a free one</label>
                                </div>
                            </div>
                        </div>

                        <div class="media-box d-flex ac">
                            <div>
                                <h3 class="activity-title">SKYJUMP</h3>
                            </div>
                            <div>
                                <div :class="'activity-box no-min-height d-flex align-items-center'">
                                    <select class="select" id="dl-sj" v-select2 v-model="discountLogicSettings.sj">
                                        <option v-for="index in 15" :key="index" :value="index" :selected="discountLogicSettings.sj == index">{{ index }}</option>
                                    </select>
                                    <label>activities to get a free one</label>
                                </div>
                            </div>
                        </div>

                        <div class="media-box d-flex ac">
                            <div>
                                <h3 class="activity-title">SKYWALK</h3>
                            </div>
                            <div>
                                <div :class="'activity-box no-min-height d-flex align-items-center'">
                                    <select class="select" id="dl-sw" v-select2 v-model="discountLogicSettings.sw">
                                        <option v-for="index in 15" :key="index" :value="index" :selected="discountLogicSettings.sw == index">{{ index }}</option>
                                    </select>
                                    <label>activities to get a free one</label>
                                </div>
                            </div>
                        </div>

                        <div class="media-box d-flex ac">
                            <div>
                                <h3 class="activity-title">TOWERCLIMB</h3>
                            </div>
                            <div>
                                <div :class="'activity-box no-min-height d-flex align-items-center'">
                                    <select class="select" id="dl-tc" v-select2 v-model="discountLogicSettings.tc">
                                        <option v-for="index in 15" :key="index" :value="index" :selected="discountLogicSettings.tc == index">{{ index }}</option>
                                    </select>
                                    <label>activities to get a free one</label>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="media-status-p">
                        <p>Changes will take immediate effect!</p>
                        <p>System will count the ratio of paid to free activities and apply FREE label automatically.</p>
                        <p>Individual activity status can be changed in the discount pass view later if necessary.</p>
                    </div>

                    <div class="actions">
                        <div class="d-flex align-items-center">
                            <button :disabled="isSubmitted" @click="updateSettings" type="submit" class="submit" name="save">Save Changes</button>
                            <a href="/ap/cr" class="cancel">Cancel</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {mapActions, mapState} from 'vuex';

export default {
    data() {
        return {
            isSubmitted: false
        }
    },
    computed: {
        ...mapState(['discountLogicSettings'])
    },
    methods: {
        ...mapActions(['fetchDiscountLogic']),
        updateSettings() {
            this.isSubmitted = true;

            axios.post('/ap/cr/discount-logic-update', {'discount_logic': this.$store.state.discountLogicSettings})
                .then(({data}) => {
                    toastr.success("Discount logic successfully updated.");
                    this.isSubmitted = false;
                })
                .catch(error => {
                    this.isSubmitted = false;
                    toastr.error(error.response.data.message);
                });
        },
    },
    async mounted() {
        await this.fetchDiscountLogic();

        $("select.select").select2({
            minimumResultsForSearch: Infinity,
            width: '81px',
        });
    }
}
</script>

<style lang="scss">
    #discount-logic {
        .select2.select2-container {
            max-width: 58px;
        }

        .select2-container .select2-selection--single {
            height: 44px;
        }

        .select2-container .select2-selection--single .select2-selection__rendered {
            padding: 6px 15px 6px 10px;
            font-weight: 700;
            text-align: center;
        }

        .select2-container--default .select2-selection--single .select2-selection__arrow {
            height: 41px;
        }

        .ac {
            align-items: center;
        }
    }
</style>